import script from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastersList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastersList.vue?vue&type=style&index=0&id=7c88e0e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c88e0e1"]])

export default __exports__